import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=3b5f3e38"
import script from "./rules.vue?vue&type=script&lang=js"
export * from "./rules.vue?vue&type=script&lang=js"
import style0 from "./rules.vue?vue&type=style&index=0&id=3b5f3e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports